import { config } from "@hotwired/turbo"

const dialog = () => document.getElementById("turbo-confirm-dialog")
const message = () => document.getElementById("turbo-confirm-message")
const okBtn = () => document.getElementById("turbo-confirm-ok")
const cancelBtn = () => document.getElementById("turbo-confirm-cancel")
const backdrop = () => document.getElementById("turbo-confirm-backdrop")

config.forms.confirm = (question) => {
  return new Promise((resolve) => {
    message().textContent = question
    dialog().showModal()

    const finish = (result) => {
      dialog().close()
      resolve(result)
    }

    okBtn().onclick = () => finish(true)
    cancelBtn().onclick = () => finish(false)
    backdrop().onclick = () => finish(false)
  })
}
